import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { DialogBox } from './Styles/RenameBucketDialogBox';

import { updateBucket } from '../../../actions/inventoryActionsV2';
import { updateError } from '../../../actions/commonActions';

const RenameBucketDialogBox = ({ open, bucket, bucketItems, onTrue, onFalse, ...props }) => {
	const onTrueHandler = async (bucketName) => {
		if (['Base Price', ...bucketItems.map((bucket) => bucket.alias)].filter((bucketAlias) => bucketAlias.toLowerCase() === bucketName.toLowerCase()).length > 0) {
			props.updateError(true, 'Bucket name already exists.');
			return;
		}

		await props.updateBucket(bucketName, bucket);
		onTrue();
	};

	const onFalseHandler = () => {
		onFalse();
	};

	useEffect(() => {}, [open, bucket]);

	return (
		<DialogBox
			open={open}
			title={'Rename Bucket'}
			label={'New Name For Bucket'}
			textField={true}
			textFieldRequired={true}
			placeholder={'Enter new name'}
			onTrue={(value) => {
				onTrueHandler(value);
			}}
			onFalse={() => {
				onFalseHandler();
			}}
		/>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
		bucketItems: state.inventory.bucketItems,
	};
};

const mapFunctionsToProps = {
	updateBucket,
	updateError,
};

export default connect(mapStatesToProps, mapFunctionsToProps)(RenameBucketDialogBox);
